import { Component, Input } from '@angular/core';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { IReport } from '../../../../interfaces/reports';
import { ICostCenter } from '../../../../interfaces/cost-center';
import { DecimalPipe, PercentPipe, CurrencyPipe } from '@angular/common';
import * as moment from 'moment';

@Component({
  selector: 'group-view',
  templateUrl: './group-view.component.html',
  styleUrls: ['../../reports.component.scss', './group-view.component.scss'],
  providers: [PercentPipe, DecimalPipe, CurrencyPipe]
})
export class GroupViewComponent {

  @Input() reports: IReport[];
  @Input() groups: ICostCenter[];

  @Input() set selectedGroups(groups: string | string[]) {
    this.groupsFilter = groups;

    if (typeof groups === 'string') {
      this.groupsRows = this.groups.map(el => this.getCurrentGroupData(el));
    } else {
      this.groupsRows = this.groups.filter(el => groups.includes(el.id)).map(el => this.getCurrentGroupData(el));
    }
  }

  groupsFilter: string | string[] = 'all';
  columnModes = ColumnMode;
  groupsRows: any = [];

  groupsColumns = [
    { prop: 'name', name: 'Unidade', flexGrow: 2 },
    { prop: 'registered', name: 'Cadastrados', flexGrow: 1 },
    { prop: 'adhered', name: 'Aderidos', flexGrow: 1 },
    { prop: 'adhered_registered', name: '% Aderidos - Cadastrados', flexGrow: 1 },
    { prop: 'use', name: 'Usuários Únicos (USO)', flexGrow: 1 },
    { prop: 'use_adhered', name: '% Uso - Aderidos', flexGrow: 1 },
    { prop: 'use_registered', name: '% Uso - Cadastrados', flexGrow: 1 },
    { prop: 'coupons', name: 'Cupons', flexGrow: 1 },
  ];

  detailsGroupColumns = [
    { prop: 'period', name: 'Período', flexGrow: 2 },
    { prop: 'registered', name: 'Cadastrados', flexGrow: 1 },
    { prop: 'adhered', name: 'Aderidos', flexGrow: 1 },
    { prop: 'adhered_registered', name: '% Aderidos - Cadastrados', flexGrow: 1 },
    { prop: 'use', name: 'Usuários Únicos (USO)', flexGrow: 1 },
    { prop: 'use_adhered', name: '% Uso - Aderidos', flexGrow: 1 },
    { prop: 'use_registered', name: '% Uso - Cadastrados', flexGrow: 1 },
    { prop: 'coupons', name: 'Cupons', flexGrow: 1 },
  ];

  constructor(private percentPipe: PercentPipe, private decimalPipe: DecimalPipe, private currencyPipe: CurrencyPipe) {}

  getCurrentGroupData(group, index = 0) {
    const groupReport = this.reports[index].data_by_cost_center.find(el => el.costCenter === group.id);
    const adhered_registered = groupReport ? this.formatPercent(groupReport.adhered_registered) : '-';
    const use_registered = groupReport ? this.formatPercent(groupReport.use_registered) : '-';
    const use_adhered = groupReport ? this.formatPercent(groupReport.use_adhered) : '-';
    const launchedEconomy = groupReport ? (groupReport.couponLaunchedEconomy + groupReport.cinema_value) || 0 : '-';

    return ({
      id: group.id,
      name: group.name,
      ...groupReport,
      adhered_registered,
      use_adhered,
      launchedEconomy,
      use_registered,
      registered: groupReport && groupReport.registered || '-',
      adhered: groupReport && groupReport.adhered || '-',
      use: groupReport && groupReport.use || '-',
      coupons: groupReport && groupReport.coupons || '-',
    });
  }

  getGroupTableData(group) {
    return this.reports.map((el, index) => {
      const lineReport = this.getCurrentGroupData(group, index);

      return {
        ...lineReport,
        period: moment.utc(el.date).format('MMM/YY')
      };
    });
  }

  formatNumber(value) {
    try {
      return this.decimalPipe.transform(value, '1.0-3');
    } catch (e) {
      return '-';
    }
  }

  formatPercent(value) {
    try {
      return this.percentPipe.transform(value, '1.2-2');
    } catch (e) {
      return '-';
    }
  }

  formatCurrency(value) {
    try {
      return this.currencyPipe.transform(value, 'BRL', 'symbol', '1.2-2');
    } catch (e) {
      return '-';
    }
  }
}
